import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LinkCompartilhamentoPage } from '@/features/link-compartilhamento/page/LinkCompartilhamentoPage';
import { LinkCompartihamentoPageTipoSchema } from '@/features/link-compartilhamento/types/LinkCompartilhamentoTipo';

export const Route = createFileRoute('/p/compartilhamento/$id')({
    component: Component,
    validateSearch: z.object({
        registrarVisualizacao: z.boolean().optional().default(false),
        tipo: LinkCompartihamentoPageTipoSchema,
    }),
});

function Component() {
    const { id } = Route.useParams();
    const { registrarVisualizacao, tipo } = Route.useSearch();

    return (
        <LinkCompartilhamentoPage
            id={id}
            registrarVisualizacao={registrarVisualizacao}
            tipo={tipo}
        />
    );
}
